var _style, _path, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .utilities-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:10;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "utilities-st0",
    d: "M336.2,225.8H23.9c-4.5,0-8.1-3.7-8.1-8.1v-75.3c0-4.5,3.7-8.1,8.1-8.1h312.3c4.5,0,8.1,3.7,8.1,8.1v75.3 C344.4,222.1,340.7,225.8,336.2,225.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "utilities-st0",
    cx: 180.1,
    cy: 179.9,
    r: 92.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "utilities-st0",
    x1: 87.7,
    y1: 179.9,
    x2: 272.5,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    className: "utilities-st0",
    x1: 180.1,
    y1: 272.4,
    x2: 180.1,
    y2: 87.6
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "utilities-st0",
    cx: 180.1,
    cy: 180,
    r: 19.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities);
export default __webpack_public_path__ + "static/media/utilities.5c0543ff0ae373e196669afbfd269781.svg";
export { ForwardRef as ReactComponent };